import { render, staticRenderFns } from "./CcsqdDetail.vue?vue&type=template&id=213379e8&scoped=true&"
import script from "./CcsqdDetail.vue?vue&type=script&lang=js&"
export * from "./CcsqdDetail.vue?vue&type=script&lang=js&"
import style0 from "./CcsqdDetail.vue?vue&type=style&index=0&id=213379e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213379e8",
  null
  
)

export default component.exports